module.exports = __webpack_public_path__ + "static/img/gold_button.45475b9e.png";